
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ticketing/[ticketingId]",
      function () {
        return require("private-next-pages/ticketing/[ticketingId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ticketing/[ticketingId]"])
      });
    }
  